module.exports = __webpack_public_path__ + "media/Main-Page-McCormick.6035893c.mp4";